export default __webpack_public_path__ + "static/media/content_tab01_02.aadcabf1.jpg";